/* global G */

/**
 * Too Many Requests error dialog
 *
 * Displays an error informing the user that they have send too many requests to the server.
 *
 * To be displayed when a response with code 429 is received from the server.
 *
 * @param {Gaia.Web.Application} obj  the Web platform Application
 */
export default (obj) => {
  const eventBus = obj[G.ADAPTER][G.EVENTS]

  eventBus.dispatch(eventBus.type(G.DATA, G.UNDO), {
    title: obj[G.ADAPTER][G.INTL]._t(
      'dialog.error.tooManyRequests.title',
      {
        ns: 'common',
        _key: 'dialog.error.tooManyRequests.title',
        defaultValue: 'Error',
      },
    ),
    text: obj[G.ADAPTER][G.INTL]._t(
      'dialog.error.tooManyRequests.text',
      {
        ns: 'common',
        _key: 'dialog.error.tooManyRequests.text',
        defaultValue: 'You have sent too many requests to the server, please try again later',
      },
    ),
    children: {
      ok: {
        key: 'ok',
        value: obj[G.ADAPTER][G.INTL]._t(
          'button.ok',
          {
            ns: 'common',
            _key: 'button.ok',
            defaultValue: 'Ok',
          },
        ),
      },
    },
  })
}
